import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './router'
import axios from "axios";

Vue.use(VueRouter)

Vue.config.productionTip = false
window.RequestHost = ""

// 设置 Axios 的基础 URL
// axios.defaults.baseURL = 'http://localhost:8080';
axios.defaults.baseURL = 'https://m.qrpay.cdjycd.com';

const router = new VueRouter({
  routes: routes
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
